import React, { useEffect, useState } from 'react'
import { config } from './config'
import './styles.scss'
import { EasyChart } from 'components/EasyChart'

let months = [
  'Jan.',
  'Feb.',
  'März',
  'Apr',
  'Mai',
  'Jun.',
  'Jul.',
  'Aug.',
  'Sep.',
  'Okt.',
  'Nov.',
  'Dez.'
]
export const RegionCharts: React.FC<BaseChartProps> = ({
  regionsData,
  scaleHeight,
  hTicks,
  title,
  subtitle,
  vTicksHidden,
  annotations,
  source
}) => {
  const [drawData, setDrawData] = useState<{
    name: string
    elements: EasyChartDrawData
  }>()
  useEffect(() => {
    fetch(regionsData)
      .then(response => {
        return response.json()
      })
      .then(data => {
        console.log(data)
        let dd = []

        data.forEach(function(d) {
          let tote = d.filter(f => f.sK).map(m => m.sK)
          let expected = d.filter(f => f.uG && f.oG).map(m => [m.uG, m.oG])

          let areTicksHidden = vTicksHidden
            ? vTicksHidden.includes(d[0].id)
            : false
          dd.push({
            name: d[0].name,
            elements: [
              {
                type: 'vticks',
                values: areTicksHidden
                  ? []
                  : [
                      [0.1, '2020'],
                      [13, 'Apr.'],
                      [27, 'Juli'],
                      [40, 'Okt.']
                    ],
                className: 'horizontalTicks'
              },
              {
                type: 'hticks',
                values: hTicks,
                className: 'horizontalTicks'
              },
              { type: 'curve', values: tote, className: 'over' },
              { type: 'area', values: expected, className: 'expected' },
              {
                type: 'curve',
                values: tote,
                className: 'under',
                clipped: expected
              },
              {
                type: 'annotations',
                values: annotations[d[0].id] ? annotations[d[0].id] : [],
                className: 'annotations'
              }
            ]
          })
        })

        setDrawData(dd)
      })
  }, [])
  console.log(drawData)
  return (
    <div className='ui vertical very fitted segment'>
      <div className='title'>{title}</div>
      <div className='sub' style={{ marginBottom: '2em' }}>
        {subtitle}
      </div>
      <div className='key'>
        <div className='entry'>
          <img className='icon' src={require('images/ueb_key-02.svg')} />
          <div className='label'>Über- bzw. Untersterblichkeit</div>
        </div>
        <div className='entry'>
          <img className='icon' src={require('images/ueb_key-03.svg')} />
          <div className='label'>Statistisch zu erwartender Bereich</div>
        </div>
      </div>
      <div className='ui container regionChartWrapper'>
        {drawData &&
          drawData.map(m => {
            return (
              <div className='regionChart'>
                <div className='regiontitle'>{m.name}</div>
                <EasyChart
                  data={m?.elements}
                  y={[0, scaleHeight + scaleHeight / 4]}
                  heights={[200, 180]}
                />
              </div>
            )
          })}
      </div>
      <div className='source'>Quelle: {source}</div>
    </div>
  )
}
